import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab, Modal, Button, Form } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import DataTable from 'react-data-table-component';
import { formatTime, getFlexClasses, getInstructorDetails, getInstructorList, getLanguage } from '../../Utils/utils';
import moment from "moment/moment";
import momenttimezone from "moment-timezone";
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import LoadingSpinner from "../LoadingSpinner";
import Select from 'react-select';
import { ToastContainer } from "react-toastify";
import axios from "axios";
import config from "../../config/config";

const CanBeAddedModal = (props) => {
  const { showModal, setShowModal, canAddedData, onProceed,
    lang_id, setIsSetup, setCloseRow, selectedRow, setSelectedRow, closeRow, showTime, newInstArr, fromGrouped

  } = props;
  const [showInstDetail, setShowInstDetail] = useState(false);
  const [isNoInst, setIsNoInst] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [instList, setInstList] = useState([]);
  const [instVal, setInstVal] = useState('');
  const [instDetail, setInstDetail] = useState('');
  const [isInstructorAccepted, setIsInstructorAccepted] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isDisableBtn, setIsDisableBtn] = useState(true);

  const handleCloseModal = () => {
    setShowModal(false)
  }

  // const getInstructor = async () => {
  //   var temp = []
  //   var res = await getInstructorList(lang_id)
  //   res.map((e) => {
  //     temp.push({
  //       value: e.id, label: e.first_name + ' ' + e.last_name, language_id: e.select_language
  //     })
  //   })
  //   setInstList(temp)
  // }

  // useEffect(() => {
  //   getInstructor()
  // }, [lang_id])

  const getInstructorDetail = async (val, lang) => {
    var res = await getInstructorDetails(val, lang)
    if (res.status == 200) {
      setInstDetail(res.data.data)
    }
  }

  useEffect(() => {
    if (instVal !== "") {
      getInstructorDetail(instVal.value, instVal.language_id)
    }
  }, [instVal])

  const saveSetup = async () => {

    setShowModal(false)
    onProceed()
    //   // setIsSetup(true)
    //   selectedRow.instructorName = `${instDetail?.first_name} ${instDetail?.last_name}`
    //   selectedRow.instructorId = instDetail?.id
    //   selectedRow.instructorEmail = `${instDetail?.email}`
    //   selectedRow.instructorAccepted = isInstructorAccepted
    //   selectedRow.isReadyToApprove = true
    //   setSelectedRow(selectedRow);
  }

  // useEffect(() => {
  //   console.log(selectedRow, "123123");
  //   if (selectedRow?.instructorId !== null) {
  //     setShowInstDetail(true)
  //     getInstructorDetail(selectedRow?.instructorId, selectedRow.language?.id)
  //     setIsDisable(false)
  //   }
  // }, [selectedRow])
  // console.log(canAddedData)
  const newTime = (time) => {
    let newMatch = time.split('&&&')
    let newArray = []
    newMatch.map((a) => {
      if (a !== "") {
        newArray.push(a)
      }
    })
    return newArray
  }
  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>

            <Modal.Title> Group Information </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* {fromGrouped == 1 ? null :
              <Row>
                <Col md={6}>
                  <div className="modal-select">
                    <Select
                      name="colors"
                      options={instList}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      placeholder="Please select instructor"
                      onChange={(e) => {
                        setIsDisable(false)
                        setInstVal(e)
                        setShowInstDetail(true)
                      }}
                    />
                  </div>
                </Col>
                {isNoInst == true ?
                  <Col md={6}>
                    <div className="mb-3">
                      <input className="form-control mb-2" type="password" name="password"
                        placeholder={("Enter instructor name")}
                      />
                    </div>
                  </Col> : null}
              </Row>
            } */}
            {/* {showInstDetail == true ? */}
            <>
              <Row className="mb-2 mt-3">
                <Col md={5}>
                  <div className="inst-det">
                    Class Number :
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets">
                    {canAddedData?.mainClassNumber}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    Start Date:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets">
                    {momenttimezone.tz(canAddedData?.availableStartDate, 'UTC').format('MM/DD/YYYY')}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    Number of students in class:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets">
                    {canAddedData?.students.length}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    Group Schedule:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets" style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}>
                    {newTime(canAddedData.matchedIn).map((a) => (
                      <>
                        {a !== "" ?
                          <div className='cell-up' style={{ fontSize: '12px' }}>{a}</div>
                          : null}
                      </>
                    ))}
                  </div>
                </Col>
              </Row>
              {/* <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    Ready for SOU:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets"
                    style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}
                  >
                    {canAddedData?.souPending}
                  </div>
                </Col>
              </Row> */}
              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    SOU Signed:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets"
                    style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}
                  >
                    {canAddedData?.souSigned}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    SOU Pending:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets"
                    style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}
                  >
                    {canAddedData?.souSent}
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md={5}>
                  <div className="inst-det">
                    Total Students:
                  </div>
                </Col>
                <Col md={7}>
                  <div className="inst-dets"
                    style={{
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                    }}
                  >
                    {canAddedData?.totalStudents}
                  </div>
                </Col>
              </Row>

            </>
            {/* : null} */}

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary"
              disabled={canAddedData?.totalStudents > 3}
              onClick={() => {
                saveSetup()
              }}>
              Add to class
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default CanBeAddedModal